import { Enrolment } from '@/models/enrolment';
import { EnrolmentStatus } from '@/models/enrolment-status';
import EnrolmentService from '@/services/enrolments-service';

import { EnrolmentNotRecognizedTriggerPayloadConfiguration } from '../trigger-payload/enrolment-not-recognized-trigger-payload-configuration';
import { TriggerPayload } from '../trigger-payload/trigger-payload';
import { TransitionTrigger } from './transition-trigger';

export class EnrolmentNotRecognizedTrigger extends TransitionTrigger {
	public constructor(excludedEnrolmentStatuses: EnrolmentStatus[]) {
		super('Student known, not enrolled', excludedEnrolmentStatuses, new EnrolmentNotRecognizedTriggerPayloadConfiguration());
	}

	public equals(that: TransitionTrigger): boolean {
		return that instanceof EnrolmentNotRecognizedTrigger;
	}

	protected async performTransitions(enrolments: Readonly<Enrolment[]>, payload: TriggerPayload): Promise<void> {
		await EnrolmentService.triggerEnrolmentNotRecognized(enrolments, payload.note || '');
	}
}
